import { IPremadeQuiz } from '@quizzach/interfaces';

export const sortBySectionOrder = (a: IPremadeQuiz, b: IPremadeQuiz) =>
	(a.section_order ?? 0) - (b.section_order ?? 0);

export const sortByCreatedAt = (a: IPremadeQuiz, b: IPremadeQuiz) =>
	(a.created_at ?? 0) - (b.created_at ?? 0);
